import {issuers} from '@apps-common/auth';
import {APPS, ENVIRONMENTS} from '@apps-common/ui-components/apps.jsx';
import {LicenseInfo} from '@mui/x-license';

// Types ------------------------------------------------------------------

type DeployEnv = 'staging' | 'production';

type URL = string;

type AppLinksConfig = {
  account?: URL;
  browser?: URL;
  configuration?: URL;
  data?: URL;
  explorer?: URL;
  featuresManager?: URL;
  stories?: URL;
  tasking?: URL;
};

type AuthConfig = {
  clientId?: string;
  issuer?: string;
};

// General ----------------------------------------------------------------

const env = import.meta.env;

export const IS_STAGING_AUTH = env.VITE_AUTH_TARGET === 'staging';

// staging auth/API
// TODO: export types from apps-common/ui-components
export const DEPLOY_ENV =
  (env.VITE_DEPLOY_ENV as DeployEnv) ?? ENVIRONMENTS.staging;

export const IS_DEV = env.MODE === 'development';

// Authentication ---------------------------------------------------------

export const AUTH: AuthConfig = {};

AUTH.issuer =
  env.VITE_AUTH_ISSUER ??
  (IS_STAGING_AUTH ? issuers.staging : issuers.production);

AUTH.clientId =
  env.VITE_AUTH_CLIENT_ID ??
  (IS_STAGING_AUTH
    ? env.VITE_AUTH_CLIENT_ID_STAGING_DEV
    : env.VITE_AUTH_CLIENT_ID_PROD_DEV);

// App links --------------------------------------------------------------

export const APP_LINKS: AppLinksConfig = {};

APP_LINKS.account = env.VITE_ACCOUNT_URL ?? APPS.account.href[DEPLOY_ENV];

APP_LINKS.browser = env.VITE_BROWSER_URL ?? APPS.browser.href[DEPLOY_ENV];

APP_LINKS.configuration =
  env.VITE_CONFIGURATION_URL ?? APPS.configurationManager.href[DEPLOY_ENV];

APP_LINKS.data = APPS.data.href[DEPLOY_ENV];

APP_LINKS.explorer = env.VITE_EXPLORER_URL ?? APPS.explorer.href[DEPLOY_ENV];

APP_LINKS.featuresManager =
  env.VITE_FEATURES_MANAGER_URL ?? APPS.featuresManager.href[DEPLOY_ENV];

APP_LINKS.stories = env.VITE_STORIES_URL ?? APPS.stories.href[DEPLOY_ENV];

APP_LINKS.tasking = env.VITE_TASKING_URL ?? APPS.tasking.href[DEPLOY_ENV];

// External/misc ----------------------------------------------------------

export const CHAMELEON_SUPERRES_TOUR_ID = '6931862b660c6400309994da';

export const LD_CLIENTSIDE_ID =
  env.VITE_LD_CLIENTSIDE_ID ??
  {
    production: env.VITE_LD_CLIENTSIDE_ID_PROD,
    staging: env.VITE_LD_CLIENTSIDE_ID_STAGING ?? '662b9f3a0a3e70106fd55f61',
    local: '662b9f49db0cc60fb29d0302',
  }[IS_DEV ? 'local' : DEPLOY_ENV];

export const GOOGLE_MAPS_API_KEY = env.VITE_GOOGLE_MAPS_API_KEY;

// demo mapbox access token only works on localhost
export const MAPBOX_ACCESS_TOKEN =
  env.VITE_MAPBOX_ACCESS_TOKEN ||
  'pk.eyJ1IjoicGxhbmV0IiwiYSI6ImNtNmF5bm1tZDAydGkya3B4NjI1NHM0NHIifQ.JN9OKpu_ocjgWGC0P6moCA';

export const NOTIFICATIONS_ENV =
  AUTH.issuer === issuers.production
    ? ENVIRONMENTS.production
    : ENVIRONMENTS.staging;

// MUI X license ----------------------------------------------------------

LicenseInfo.setLicenseKey(env.VITE_MATERIAL_UI_X_KEY);

// the end --------------------------------------------------------------------
